<template>
  <div class="wrap">
    <div class="header">
      <div class="logo">spharos</div>
      <div
        class="box-gray hdr-notice em"
        v-if="isNotice"
        style="position: absolute; z-index: 2"
      >
        <i class="ico-notice"></i>
        <div class="notice-txt">
          <div class="marquee-txt">
            {{ claimMessage }}
          </div>
        </div>
        <div class="notice-btn">
          <button
            type="button"
            class="btn-top"
            @click="
              isNotice = false;
              $store.getters.getBaskets.isNotice = false;
            "
          >
            닫기
          </button>
        </div>
      </div>
      <div class="box-gray hdr-info">
        <span class="dt">매장명</span>
        <span class="dd ellipsis">{{ titleName }}</span>
        <span class="dt">포스번호</span>
        <span class="dd">POS-001</span>
        <span class="dt">사용자</span>
        <span class="dd">홍길동</span>
        <span class="dt">영업일자</span>
        <span class="dd">{{ tableTime }}</span>
      </div>
      <!-- 붉은 와이파이: 아래 요소에 off 클래스 추가 -->

      <button
        type="button"
        class="btn-sm btn-yellow"
        :class="{ disabled: isToggle1 }"
        @click="isToggle1 ? (isToggle1 = false) : (isToggle1 = true)"
      >
        <i class="icon ico-print"></i>영수증<span class="overlay"></span>
      </button>
      <button
        type="button"
        class="btn-sm btn-yellow"
        :class="{ disabled: isToggle2 }"
        @click="isToggle2 ? (isToggle2 = false) : (isToggle2 = true)"
      >
        <i class="icon ico-print"></i>주방<span class="overlay"></span>
      </button>
      <button
        type="button"
        class="btn-close"
        @click="
          if (tableYn == 'Y') this.$router.push('/order/table');
          else this.$router.push('/');
        "
      >
        닫기<span class="overlay"></span>
      </button>
      <span class="icon ico-wifi"></span>
    </div>
    <div class="content flex">
      <div class="half">
        <div class="item">
          <table class="tb-lst-prod">
            <thead>
              <tr>
                <td>No.</td>
                <td>상품명</td>
                <td>단가</td>
                <td>수량</td>
                <td>할인</td>
                <td>금액</td>
                <td>비고</td>
              </tr>
            </thead>
            <!-- [1023수정] 키패드 숨기기, 보이기 -->
            <tbody id="bodyExp" :class="{ open: isHideKeypad }">
              <template
                v-for="(basket, index) in isReceipt ? receiptBasket : baskets"
                :key="index"
              >
                <tr
                  :class="{ 'bg-selected': activeBasket == index.toString() }"
                  :id="index"
                  @click="
                    isReceipt
                      ? null
                      : isDiscount
                      ? (activeBasket = index)
                      : isDisabled == false
                      ? (activeBasket = index)
                      : null
                  "
                >
                  <td>{{ index + 1 }}</td>
                  <td>{{ basket.name }}</td>
                  <td>
                    {{
                      basket.price
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}
                  </td>
                  <td>{{ basket.qty }}</td>
                  <td>
                    {{
                      (basket.discount * basket.qty)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}
                  </td>
                  <td>
                    {{
                      (basket.price * basket.qty - basket.discount * basket.qty)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}
                  </td>
                  <td>
                    <template v-if="basket.event == true">
                      <span class="tag tag-blue">행사</span>
                    </template>
                    <template
                      v-if="basket.event == false && basket.discount > 0"
                    >
                      <span class="tag tag-pink">할인</span>
                    </template>
                  </td>
                </tr>
                <template
                  v-for="(option, optionIndex) in basket.optionList"
                  :key="optionIndex"
                >
                  <tr
                    :class="{
                      'bg-selected':
                        activeBasket ==
                        `${index.toString()}_${optionIndex.toString()}`,
                    }"
                    :id="`${index.toString()}_${optionIndex.toString()}`"
                    @click="
                      isProdPay
                        ? null
                        : isDisabled == false
                        ? (activeBasket = `${index.toString()}_${optionIndex.toString()}`)
                        : null
                    "
                  >
                    <td></td>
                    <td>ㄴ {{ option.selectItemNm }}</td>
                    <td>
                      {{
                        option.selectItemPrice
                          .toString()
                          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                      }}
                    </td>
                    <td>{{ option.selectItemCnt }}</td>
                    <td>
                      {{
                        option.selectItemDiscount
                          .toString()
                          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                      }}
                    </td>
                    <td>
                      {{
                        (
                          (option.selectItemPrice - option.selectItemDiscount) *
                          option.selectItemCnt
                        )
                          .toString()
                          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                      }}
                    </td>
                    <td></td>
                  </tr>
                </template>
              </template>
            </tbody>
          </table>
        </div>

        <!--상품별 결제 -->
        <div class="item" v-if="isProdPay">
          <div class="dutchpay-wrap">
            <div class="flex">
              <!-- btn-has-arr: 아래로 이동, 위로 이동은 up 클래스 추가 -->
              <button
                type="button"
                class="btn-has-arr"
                :class="{ up: activeProdBasket != -1 }"
                @click="prodMove()"
              >
                {{ activeProdBasket != -1 ? "위로 이동" : "아래로 이동"
                }}<span class="overlay"></span>
              </button>
              <div class="w-box-shadow">
                <span>총 결제금액</span>
                <span>{{
                  prodAmount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }}</span>
              </div>
              <button type="button" class="btn-close" @click="prodPayCencel()">
                닫기<span class="overlay"></span>
              </button>
            </div>
            <div class="flex">
              <table class="tb-lst-payment tb-dutchpay">
                <tbody id="prodBasketScroll">
                  <template
                    v-for="(basket, index) in prodPayBaskets"
                    :key="index"
                  >
                    <tr
                      :class="{
                        on: activeProdBasket == index.toString(),
                      }"
                      :id="index"
                      @click="
                        activeProdBasket == index.toString()
                          ? (activeProdBasket = -1)
                          : (activeProdBasket = index)
                      "
                    >
                      <td>{{ index + 1 }}</td>
                      <td>
                        <span class="ellipsis">{{ basket.name }}</span>
                      </td>
                      <td>
                        {{
                          basket.price
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        }}
                      </td>
                      <td>{{ basket.qty }}</td>
                      <td>
                        {{
                          (basket.discount * basket.qty)
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        }}
                      </td>
                      <td>
                        {{
                          (
                            basket.price * basket.qty -
                            basket.discount * basket.qty
                          )
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        }}
                      </td>
                    </tr>
                    <template
                      v-for="(option, optionIndex) in basket.optionList"
                      :key="optionIndex"
                    >
                      <tr
                        :class="{
                          on: activeProdBasket == index.toString(),
                        }"
                      >
                        <td></td>
                        <td>
                          <span class="ellipsis"
                            >ㄴ {{ option.selectItemNm }}</span
                          >
                        </td>
                        <td>
                          {{
                            option.selectItemPrice
                              .toString()
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                          }}
                        </td>
                        <td>{{ option.selectItemCnt }}</td>
                        <td>
                          {{
                            option.selectItemDiscount
                              .toString()
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                          }}
                        </td>
                        <td>
                          {{
                            (
                              (option.selectItemPrice -
                                option.selectItemDiscount) *
                              option.selectItemCnt
                            )
                              .toString()
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                          }}
                        </td>
                      </tr>
                    </template>
                  </template>
                </tbody>
              </table>
              <div class="tb-side-btn">
                <button
                  type="button"
                  class="btn-side-up"
                  @click="prodBasketMove(-50)"
                >
                  위로<span class="overlay"></span>
                </button>
                <button
                  type="button"
                  class="btn-side-down"
                  @click="prodBasketMove(50)"
                >
                  아래로<span class="overlay"></span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div v-if="!isProdPay">
          <div class="item">
            <div class="buttons">
              <!-- [1023수정] 키패드 숨기기, 보이기 버튼 추가 -->
              <button
                type="button"
                class="btn-toggle"
                :class="{ hide: !isHideKeypad }"
                :disabled="isDisabled"
                id="toggleBtn"
                @click="
                  isHideKeypad ? (isHideKeypad = false) : (isHideKeypad = true)
                "
              >
                <span class="overlay"></span>
              </button>
              <button
                type="button"
                class="btn-md3 btn-yellow"
                :disabled="isDisabled"
                @click="removeItem"
              >
                선택<br />취소<span class="overlay"></span>
              </button>
              <button
                type="button"
                class="btn-md3 btn-yellow"
                :disabled="isDisabled"
                @click="setPopupData(1)"
              >
                전체<br />취소<span class="overlay"></span>
              </button>
              <button
                type="button"
                class="btn-md3 btn-yellow"
                :disabled="isDisabled"
                @click="priceChangeKeyNum(keypadNum)"
              >
                금액<br />변경<span class="overlay"></span>
              </button>
              <button
                type="button"
                class="btn-md3 btn-yellow"
                :disabled="isDisabled"
                @click="qtyChangeKeyNum(keypadNum)"
              >
                수량<br />변경<span class="overlay"></span>
              </button>
              <button
                type="button"
                class="btn-plus"
                :disabled="isDisabled"
                @click="qtyChange(1)"
              >
                추가<span class="overlay"></span>
              </button>
              <button
                type="button"
                class="btn-minus"
                :disabled="isDisabled"
                @click="qtyChange(-1)"
              >
                제거<span class="overlay"></span>
              </button>
              <button type="button" class="btn-up" @click="moveBtn(-1)">
                위로<span class="overlay"></span>
              </button>
              <button type="button" class="btn-down" @click="moveBtn(1)">
                아래로<span class="overlay"></span>
              </button>
              <div class="txt">
                <span class="dt">수량</span>
                <span class="dd">{{ totalQty }}</span>
              </div>
            </div>
          </div>
          <!-- [1023수정] 키패드 숨기기, 보이기 -->
          <div class="item flex" id="priceKeypad" v-if="!isHideKeypad">
            <div
              class="discount-area"
              :style="isDiscount ? { display: 'flex' } : { display: 'none' }"
            >
              <button
                type="button"
                class="dis-btn lg pk"
                @click="allDiscount('rate')"
              >
                <span class="ico-box pink">%</span>전체<br />할인<span
                  class="overlay"
                ></span>
              </button>
              <button
                type="button"
                class="dis-btn lg yl"
                @click="prodDiscount('rate')"
              >
                <span class="ico-box yellow">%</span>선택<br />할인<span
                  class="overlay"
                ></span>
              </button>
              <button
                type="button"
                class="dis-btn lg pk"
                @click="allDiscount('fix')"
              >
                <span class="ico-box pink">￦</span>전체<br />할인<span
                  class="overlay"
                ></span>
              </button>
              <button
                type="button"
                class="dis-btn lg yl"
                @click="prodDiscount('fix')"
              >
                <span class="ico-box yellow">￦</span>선택<br />할인<span
                  class="overlay"
                ></span>
              </button>
              <button
                type="button"
                class="dis-btn pk"
                @click="cancelDiscount('a')"
              >
                전체<br />할인취소
              </button>
              <button
                type="button"
                class="dis-btn yl"
                @click="cancelDiscount('s')"
              >
                선택<br />할인취소
              </button>
            </div>
            <!-- 기본 화면 -->
            <div
              class="price-area"
              v-if="!isAddInfo && !isMemberInfo"
              :style="isDiscount ? { display: 'none' } : { display: 'flex' }"
            >
              <span class="dt">총금액</span>
              <span class="dd">{{
                totalUprc.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }}</span>
              <span class="dt">할인금액(-)</span>
              <span class="dd">{{
                totalDiscount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }}</span>
              <span class="dt">부가세</span>
              <span class="dd">{{
                ((totalUprc - totalDiscount - receivedUprc) * 0.1)
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }}</span>
              <span class="dt">봉사료</span>
              <span class="dd">0</span>
              <span class="dt total-price">받을금액</span>
              <span class="dd total-price">{{
                (totalUprc - totalDiscount - receivedUprc)
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }}</span>
              <span class="dt paid-money">받은금액</span>
              <span class="dd paid-money">{{
                receivedUprc.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }}</span>
            </div>
            <!-- 추가 기능 -->
            <div class="add-func-area" v-if="isAddInfo">
              <button class="btn-lg btn-white active">
                추가기능<span class="overlay"></span>
              </button>
              <button class="btn-lg btn-white">
                추가기능<span class="overlay"></span>
              </button>
              <button class="btn-lg btn-white">
                추가기능<span class="overlay"></span>
              </button>
              <button class="btn-lg btn-white">
                추가기능<span class="overlay"></span>
              </button>
              <button class="btn-lg btn-white">
                추가기능<span class="overlay"></span>
              </button>
              <button class="btn-lg btn-white">
                추가기능<span class="overlay"></span>
              </button>
              <button class="btn-lg btn-white">
                추가기능<span class="overlay"></span>
              </button>
              <button class="btn-lg btn-white">
                추가기능<span class="overlay"></span>
              </button>
              <button class="btn-lg btn-white">
                추가기능<span class="overlay"></span>
              </button>
              <button class="btn-prev"><span class="overlay"></span></button>
              <button class="btn-next"><span class="overlay"></span></button>
            </div>
            <!-- 회원 정보 -->
            <div class="price-area" v-if="isMemberInfo">
              <span class="dt">회원명</span>
              <span class="dd">홍길동</span>
              <span class="dt">회원번호</span>
              <span class="dd">00000000</span>
              <span class="dt">전화번호</span>
              <span class="dd">010-1234-5678</span>
              <span class="dt">잔여포인트</span>
              <span class="dd">999,999,999</span>
              <button class="btn-lg btn-yellow btn-btm-fix">
                초기화<span class="overlay"></span>
              </button>
            </div>

            <div class="keypad-area">
              <input
                type="text"
                id=""
                name=""
                :value="keypadNum"
                class="ip-comm"
                disabled
              />
              <div class="keypad bg-box-dark">
                <button type="button" @click="addNum('1')">
                  1<span class="overlay"></span>
                </button>
                <button type="button" @click="addNum('2')">
                  2<span class="overlay"></span>
                </button>
                <button type="button" @click="addNum('3')">
                  3<span class="overlay"></span>
                </button>
                <button type="button" @click="addNum('4')">
                  4<span class="overlay"></span>
                </button>
                <button type="button" @click="addNum('5')">
                  5<span class="overlay"></span>
                </button>
                <button type="button" @click="addNum('6')">
                  6<span class="overlay"></span>
                </button>
                <button type="button" @click="addNum('7')">
                  7<span class="overlay"></span>
                </button>
                <button type="button" @click="addNum('8')">
                  8<span class="overlay"></span>
                </button>
                <button type="button" @click="addNum('9')">
                  9<span class="overlay"></span>
                </button>
                <button type="button" class="r2c1" @click="addNum('0')">
                  0<span class="overlay"></span>
                </button>
                <button type="button" @click="addNum('00')">
                  00<span class="overlay"></span>
                </button>
              </div>
            </div>
            <div class="keypad-btns">
              <button
                type="button"
                class="btn-keypad btn-back"
                @click="addNum('remove')"
              >
                뒤로<span class="overlay"></span>
              </button>
              <button
                type="button"
                class="btn-keypad"
                :disabled="isDisabled"
                @click="prodDiscount('fix')"
              >
                &#8361;할인<span class="overlay"></span>
              </button>
              <button
                type="button"
                class="btn-keypad"
                :disabled="isDisabled"
                @click="prodDiscount('rate')"
              >
                %할인<span class="overlay"></span>
              </button>
              <button type="button" class="btn-keypad" @click="keypadNum = ''">
                C<span class="overlay"></span>
              </button>
              <button
                type="submit"
                class="btn-keypad btn-enter"
                @click="keypadEnter"
              >
                확인<span class="overlay"></span>
              </button>
            </div>
          </div>
          <div class="item" id="priceOnly" v-if="isHideKeypad">
            <div class="total-price-area">
              <div class="total-price">
                <span class="dt">받을금액</span>
                <span class="dd">{{
                  (totalUprc - totalDiscount)
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }}</span>
              </div>
              <input type="text" class="ip-comm" />
            </div>
          </div>
        </div>
        <!-- // [1023수정] 키패드 숨기기, 보이기 -->
      </div>
      <div class="half">
        <div class="item">
          <div class="box-gray notice">
            <!-- <i class="ico-warning"></i>
            <span>프린터 용지가 부족합니다.</span> -->
          </div>
        </div>

        <div class="item">
          <div class="swiper mySwiper01">
            <div class="swiper-wrapper">
              <!-- Slide 1 -->
              <div class="swiper-slide bg-box-dark">
                <!-- row02: 행 2 -->
                <div class="grid-area row02">
                  <button
                    v-for="group in groupList.slice(
                      (groupCurrentPage - 1) * groupPageCount,
                      groupCurrentPage * groupPageCount
                    )"
                    :key="group"
                    class="t-box"
                    :class="[
                      group.colorCss,
                      { 'on blink': activeGroup == group.groupIdx },
                    ]"
                    @mouseup="groupClick(group.groupIdx)"
                  >
                    <span class="mn-name">{{ group.name }}</span>
                    <span class="overlay"></span>
                  </button>
                </div>
              </div>
              <!-- //Slide 1 -->
            </div>
            <div
              class="swiper-button-prev btn-prev"
              :disabled="groupCurrentPage == 1"
              @click="if (groupCurrentPage != 1) groupCurrentPage--;"
            ></div>
            <div
              class="swiper-button-next btn-next"
              :disabled="
                groupCurrentPage == Math.ceil(groupList.length / groupPageCount)
              "
              @click="
                if (
                  groupCurrentPage !=
                  Math.ceil(groupList.length / groupPageCount)
                )
                  groupCurrentPage++;
              "
            ></div>
            <MainPaging
              :currentPage="groupCurrentPage"
              :pageCount="groupPageCount"
              :totalCount="groupList.length"
              @changePage="groupChangePage"
            />
          </div>
        </div>

        <div class="item">
          <div class="swiper mySwiper02">
            <div class="swiper-wrapper">
              <!-- Slide 1 -->
              <div class="swiper-slide bg-box-dark" style="height: 375px">
                <!-- row05: 행 5 -->
                <div class="grid-area row05">
                  <button
                    class="t-box"
                    v-for="menu in menuList.filter((obj) => {
                      return obj.groupIdx === activeGroup;
                    })"
                    :key="menu"
                    :class="[menu.colorCss, `r${menu.row}c${menu.cell}`]"
                    @click="menu.menuIdx == 0 ? null : optionModal(menu)"
                  >
                    <span class="mn-name">{{ menu.name }}</span>
                    <span class="mn-price">{{
                      menu.price
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}</span>
                  </button>
                </div>
              </div>
              <!-- //Slide 1 -->

              <!-- Slide 2 -->
              <div class="swiper-slide" style="display: none">
                #2번 슬라이드#
              </div>
              <!-- //Slide 2 -->
            </div>
            <div class="swiper-button-prev btn-prev"></div>
            <div class="swiper-button-next btn-next"></div>
            <div class="swiper-pagination">
              <span class="bullet on"></span>
              <!-- <span class="bullet"></span>
              <span class="bullet"></span> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer flex">
      <!-- [1005수정] 추가기능, 회원정보 분리 -->
      <div class="footer-header">
        <button
          type="button"
          class="ft-t-box bg-yellow"
          :class="{ on: isAddInfo }"
          disabled
          @click="
            if (isAddInfo) isAddInfo = false;
            else {
              isAddInfo = true;
              isMemberInfo = false;
              isDiscount = false;
            }
          "
        >
          <span class="txt">추가기능</span>
          <i class="icon ico-more"></i>
          <span class="overlay"></span>
        </button>
        <button
          type="button"
          class="ft-t-box bg-yellow blink"
          :class="{ on: isMemberInfo }"
          @click="
            if (isMemberInfo) isMemberInfo = false;
            else {
              isMemberInfo = true;
              isAddInfo = false;
              isDiscount = false;
            }
          "
        >
          <span class="txt">회원정보</span>
          <i class="icon ico-member"></i>
          <span class="overlay"></span>
        </button>
      </div>
      <!-- [1005수정] 4열일 경우 아래 요소(div.ft-grid-area)에 col04 클래스 추가 -->
      <div class="ft-grid-area col04">
        <button
          :class="[{ 'bg-indigo': desc.idx != 0 }]"
          :disabled="btnDisabled2(desc)"
          :id="desc.code"
          type="button"
          class="ft-t-box"
          v-for="desc in descList"
          :key="desc"
          :style="[
            { 'grid-row': 'span ' + desc.row },
            { 'grid-column': 'span ' + desc.col },
            { height: desc.row * 42 - 2 + 'px' },
            { width: desc.col * 100 - 2 + 'px' },
          ]"
          @click="descModal(desc.code)"
        >
          <span
            class="txt"
            :style="{ 'font-size': desc.code == 'DESC012' ? '0.73em' : '1em' }"
            >{{ desc.name }}</span
          >
          <span class="overlay"></span>
        </button>
      </div>
      <!-- [1005수정] 5열일 경우 아래 요소(div.ft-grid-area)에 col05 클래스 추가 -->
      <div class="ft-grid-area col05">
        <button
          :class="[
            { 'ft-sm': payment.isSmall },
            { 'bg-indigo': payment.idx != 0 },
          ]"
          type="button"
          class="ft-t-box"
          v-for="payment in paymentList"
          :key="payment"
          :style="[
            { 'grid-row': 'span ' + payment.row },
            { 'grid-column': 'span ' + payment.col },
            { height: payment.row * 42 - 2 + 'px' },
            { width: payment.col * 100 - 2 + 'px' },
          ]"
          @click="paymentModal(payment.code)"
        >
          <span class="txt">{{ payment.name }}</span>
          <i class="icon" :class="payment.icoCss"></i>
          <span class="overlay"></span>
        </button>
      </div>
    </div>

    <ComplexPayment
      v-if="isComplex"
      :totalUprc="totalUprc"
      :totalDiscount="totalDiscount"
      :receivedUprc="receivedUprc"
      :payType="payType"
      :cashUprc="cashUprc"
      :kakaoUprc="kakaoUprc"
      :cardUprc="cardUprc"
      :membersUprc="membersUprc"
      :naverUprc="naverUprc"
      :complexUprc="complexUprc"
      :complexPayArr="complexPayArr"
      @openLoading="openLoading"
      @closeLoading="closeLoading"
      @complexPay="complexPay"
      @close="complexClose"
      @resetBasket="resetBasket"
      @removeComplexPayArr="removeComplexPayArr"
      @complexAmount="complexAmount"
      :isProdPay="isProdPay"
      :prodAmount="prodAmount"
    />

    <DutchPayment
      v-if="isDutchPayment"
      @closeModal="
        isDutchPayment = false;
        btnDisabled(false);
        dutchUprc = 0;
      "
      :totalUprc="totalUprc"
      :totalDiscount="totalDiscount"
      :receivedUprc="receivedUprc"
      :dutchUprc="dutchUprc"
      @dutchPay="dutchPay"
      @openLoading="openLoading"
      @closeLoading="closeLoading"
      @removeComplexPayArr="removeComplexPayArr"
      @resetBasket="resetBasket"
    />

    <CardPayment
      v-if="isCard"
      @close="
        isCard = false;
        btnDisabled(false);
      "
      @keypad="isKeypad = true"
      @openLoading="openLoading"
      @closeLoading="closeLoading"
      @resetBasket="resetBasket"
      :totalUprc="totalUprc"
      :totalDiscount="totalDiscount"
      :receivedUprc="receivedUprc"
      :cashReceiveNum="cashReceiveNum"
      :payType="payType"
      :isComplex="isComplex"
      :cardTotalUprc="cardTotalUprc"
      :complexUprc="complexUprc"
      :dutchUprc="dutchUprc"
      @closeComplexCard="closeComplexCard"
      @addComplexPayArr="addComplexPayArr"
      @closeDutchCard="closeDutchCard"
      :isDutchPayment="isDutchPayment"
      :isProdPay="isProdPay"
      :prodAmount="prodAmount"
    />

    <KakaoPay
      v-if="isKakaoPay"
      @close="
        isKakaoPay = false;
        btnDisabled(false);
      "
      @openLoading="openLoading"
      @closeLoading="closeLoading"
      @resetBasket="resetBasket"
      :totalUprc="totalUprc"
      :totalDiscount="totalDiscount"
      :receivedUprc="receivedUprc"
      :payType="payType"
      :isComplex="isComplex"
      :kakaoTotalUprc="kakaoTotalUprc"
      :complexUprc="complexUprc"
      @closeComplexKakao="closeComplexKakao"
      @addComplexPayArr="addComplexPayArr"
    />

    <NaverPay
      v-if="isNaverPay"
      @close="
        isNaverPay = false;
        btnDisabled(false);
      "
      @openLoading="openLoading"
      @closeLoading="closeLoading"
      @resetBasket="resetBasket"
      :totalUprc="totalUprc"
      :totalDiscount="totalDiscount"
      :receivedUprc="receivedUprc"
      :payType="payType"
      :isComplex="isComplex"
      :naverTotalUprc="naverTotalUprc"
      :complexUprc="complexUprc"
      @closeComplexNaver="closeComplexNaver"
      @addComplexPayArr="addComplexPayArr"
    />

    <UseSale
      v-if="isUseSale"
      :totalUprc="totalUprc"
      :totalDiscount="totalDiscount"
      :receivedUprc="receivedUprc"
      :payType="payType"
      @resetBasket="resetBasket"
      @openLoading="openLoading"
      @closeLoading="closeLoading"
      @close="
        isUseSale = false;
        btnDisabled(false);
      "
    />

    <CashPayment
      v-if="isCash"
      @closeModal="
        isCash = false;
        btnDisabled(false);
      "
      @resetBasket="resetBasket"
      @moveCashReceipts="moveCashReceipts"
      @openLoading="openLoading"
      @closeLoading="closeLoading"
      :totalUprc="totalUprc"
      :totalDiscount="totalDiscount"
      :receivedUprc="receivedUprc"
      :cashReceiveNum="cashReceiveNum"
      :isComplex="isComplex"
      :complexUprc="complexUprc"
      :dutchUprc="dutchUprc"
      @closeComplexCash="closeComplexCash"
      @addComplexPayArr="addComplexPayArr"
      @closeDutchCash="closeDutchCash"
      :isDutchPayment="isDutchPayment"
      :isProdPay="isProdPay"
      :prodAmount="prodAmount"
    />
    <CashReceipt
      v-if="isCashReceipts"
      @close="
        isCashReceipts = false;
        btnDisabled(false);
      "
      @resetBasket="resetBasket"
      @openLoading="openLoading"
      @closeLoading="closeLoading"
      :cashReceiveNum="cashReceiveNum"
      :payType="payType"
    />
    <MembershipPoint
      v-if="isMembershipPoint"
      @close="
        isMembershipPoint = false;
        btnDisabled(false);
      "
      @openLoading="openLoading"
      @closeLoading="closeLoading"
      @setReceivedUprc="setReceivedUprc"
      :totalUprc="totalUprc"
      :totalDiscount="totalDiscount"
      :receivedUprc="receivedUprc"
      :payType="payType"
      :isComplex="isComplex"
      @closeComplexMembers="closeComplexMembers"
      @addComplexPayArr="addComplexPayArr"
      :membersTotalUprc="membersTotalUprc"
      :complexUprc="complexUprc"
    />
    <MembershipCoupon
      v-if="isMembershipCoupon"
      @close="
        isMembershipCoupon = false;
        btnDisabled(false);
      "
      @openLoading="openLoading"
      @closeLoading="closeLoading"
      @setReceivedUprc="setReceivedUprc"
      :totalUprc="totalUprc"
      :totalDiscount="totalDiscount"
      :receivedUprc="receivedUprc"
      :payType="payType"
    />
    <ProductSearch
      v-if="isProductSearch"
      @close="
        isProductSearch = false;
        btnDisabled(false);
      "
      @optionModal="optionModal"
    />
    <RestoreOrder
      v-if="isRestoreOrder"
      @close="
        isRestoreOrder = false;
        btnDisabled(false);
      "
      @restoreOrder="restoreOrder"
    />
    <ReturnOrder
      v-if="isReturnOrder"
      @close="
        isReturnOrder = false;
        btnDisabled(false);
      "
    />

    <Keypad v-if="isKeypad" @close="isKeypad = false" />

    <MenuOption
      v-if="isMenuOption"
      @close="isMenuOption = false"
      @setBasketOrder="setBasketOrder"
      :menuObj="menuObj"
    />

    <PopupBtn1
      v-if="isPopupBtn1"
      :popupText="popupText"
      :popupTitle="popupTitle"
      @close="
        isPopupBtn1 = false;
        btnDisabled(false);
      "
    />

    <PopupBtn2
      v-if="isPopupBtn2"
      :popupText="popupText"
      :popupTitle="popupTitle"
      @close="
        isPopupBtn2 = false;
        btnDisabled(false);
      "
      @setYes="setYes"
    />

    <LoadingText v-if="isLoadingText" :loadingText="loadingText" />

    <Receipt
      v-if="isReceipt"
      @close="
        isReceipt = false;
        btnDisabled(false);
        receiptBasket = [];
      "
      @setReceiptBaskets="setReceiptBaskets"
    />

    <CustomerManagement
      v-if="isCustomerManagement"
      @close="isCustomerManagement = false"
      @tableSetBaskets="tableSetBaskets"
    />

    <Claim v-if="isClaim" @close="isClaim = false" @claimNotice="claimNotice" />

    <Coupon
      v-if="isCoupon"
      @close="isCoupon = false"
      @applyCoupon="applyCoupon"
    />

    <OrderMenuSelectOption
      v-if="isSelectOption"
      @close="isSelectOption = false"
      @setBasketOrder="setBasketOrder"
      @popupOpen="popupOpen"
      :menuObj="menuObj"
    />
  </div>
</template>

<script>
//component
import mainPaging from "@/components/common/MainPaging.vue";
import keypad from "@/components/popup/Keypad.vue";

//modal
import cardPayment from "@/views/modal/CardPayment.vue";
import complexPayment from "@/views/modal/ComplexPayment.vue";
import cashPayment from "@/views/modal/CashPayment.vue";
import cashReceipt from "@/views/modal/CashReceipt.vue";
import membershipPoint from "@/views/modal/MembershipPoint.vue";
import membershipCoupon from "@/views/modal/MembershipCoupon.vue";
import productSearch from "@/views/modal/ProductSearch.vue";
import kakaoPay from "@/views/modal/KakaoPay.vue";
import naverPay from "@/views/modal/NaverPay.vue";
import restoreOrder from "@/views/modal/RestoreOrder.vue";
import returnOrder from "@/views/modal/ReturnOrder.vue";
import menuOption from "@/views/modal/MenuOption.vue";
import receipt from "@/views/modal/Receipt.vue";
import useSale from "@/views/modal/UseSale.vue";
import customerManagement from "@/views/modal/CustomerManagement.vue";
import dutchPayment from "@/views/modal/DutchPayment.vue";
import claim from "@/views/modal/Claim.vue";
import coupon from "@/views/modal/Coupon.vue";
import orderMenuSelectOption from "@/views/modal/OrderMenuSelectOption.vue";

import popupBtn1 from "@/components/popup/PopupBtn1.vue";
import popupBtn2 from "@/components/popup/PopupBtn2.vue";
import loadingText from "@/components/popup/LoadingText.vue";
import _ from "lodash";

export default {
  name: "orderMain",
  props: {},
  data() {
    return {
      menuList: this.$store.getters.getMenuList,
      groupList: this.$store.getters.getGroupList,
      groupPageCount: 9,
      groupCurrentPage: 1,
      paymentList: _.cloneDeep(this.$store.getters.getPaymentList),
      descList: this.$store.getters.getDescList,
      mstOptionList: this.$store.getters.getMstOptionList,
      mstItemList: this.$store.getters.getMstItemList,
      isCard: false,
      isComplex: false,
      isCashReceipts: false,
      isCash: false,
      isMembershipPoint: false,
      isMembershipCoupon: false,
      isProductSearch: false,
      isKakaoPay: false,
      isNaverPay: false,
      isRestoreOrder: false,
      isReturnOrder: false,
      isKeypad: false,
      activeGroup: 6,
      isAddInfo: false,
      isMemberInfo: false,
      isHideKeypad: false,
      isMenuOption: false,
      menuObj: null,
      baskets:
        this.$store.getters.getBaskets == null
          ? []
          : this.$store.getters.getBaskets.menuArr,
      activeBasket: -1,
      totalUprc: 0,
      totalDiscount: 0,
      totalQty: 0,
      keypadNum: "0",
      isPopupBtn1: false,
      isPopupBtn2: false,
      popupText: "",
      popupTitle: "",
      receiptYn: this.$route.params.receiptYn,
      tableYn: this.$route.params.tableYn,
      isReceipt: false,
      cashReceiveNum: "",
      isLoadingText: false,
      loadingText: "",
      isDisabled: false,
      setYesType: 0,
      payType: "",
      receivedUprc: 0,
      isUseSale: false,
      cashUprc: 0,
      kakaoUprc: 0,
      kakaoTotalUprc: 0,
      cardUprc: 0,
      cardTotalUprc: 0,
      membersUprc: 0,
      membersTotalUprc: 0,
      naverUprc: 0,
      naverTotalUprc: 0,
      complexUprc: 0,
      complexPayArr: [],
      isToggle1: false,
      isToggle2: false,
      isCustomerManagement: false,
      isDiscount: false,
      isDutchPayment: false,
      dutchUprc: 0,
      isProdPay: false,
      prodAmount: 0,
      prodPayBaskets: [],
      activeProdBasket: -1,
      isClaim: false,
      isNotice: false,
      claimMessage: "",
      isCoupon: false,
      isSelectOption: false,
      receiptBasket: [],
    };
  },
  methods: {
    dutchAmount() {
      let num = parseInt(event.target.value.replace(",", ""));
      if (num > 0) this.dutchUprc = num;
    },
    complexAmount() {
      let num = parseInt(event.target.value.replace(",", ""));
      if (num > 0) this.complexUprc = num;
    },
    keypadEnter() {
      this.complexUprc = 0;
      this.dutchUprc = 0;
      if (this.isComplex && this.isKakaoPay) {
        this.kakaoTotalUprc = this.keypadNum;
      } else if (this.isComplex && this.isCard) {
        this.cardTotalUprc = this.keypadNum;
      } else if (this.isComplex && this.isMembershipPoint) {
        this.membersTotalUprc = this.keypadNum;
      } else if (this.isComplex && this.isNaverPay) {
        this.naverTotalUprc = this.keypadNum;
      } else if (this.isComplex) {
        this.complexUprc = this.keypadNum;
      } else if (this.isDutchPayment) {
        this.dutchUprc = this.keypadNum;
      }
    },
    complexClose() {
      this.isComplex = false;
      this.complexUprc = 0;
      this.membersUprc = 0;
      this.cardUprc = 0;
      this.cashUprc = 0;
      this.kakaoUprc = 0;
      this.naverUprc = 0;

      this.kakaoTotalUprc = 0;
      this.cardTotalUprc = 0;
      this.membersTotalUprc = 0;
      this.naverTotalUprc = 0;
      this.btnDisabled(false);
    },
    closeComplexMembers(receiveCash) {
      this.isMembershipPoint = false;
      this.btnDisabled(false);
      this.receivedUprc += Number(receiveCash);
      this.membersUprc = receiveCash;
      this.complexUprc = 0;
    },
    closeComplexNaver(receiveCash) {
      this.isNaverPay = false;
      this.btnDisabled(false);
      this.receivedUprc += Number(receiveCash);
      this.naverUprc = receiveCash;
      this.complexUprc = 0;
    },
    closeComplexCard(receiveCash) {
      this.isCard = false;
      this.btnDisabled(false);
      this.receivedUprc += Number(receiveCash);
      this.cardUprc = receiveCash;
      this.complexUprc = 0;
    },
    closeComplexCash(receiveCash) {
      this.isCash = false;
      this.btnDisabled(false);
      this.receivedUprc += Number(receiveCash);
      this.cashUprc = receiveCash;
      this.complexUprc = 0;
    },
    closeComplexKakao(receiveCash) {
      this.isKakaoPay = false;
      this.btnDisabled(false);
      this.receivedUprc += Number(receiveCash);
      this.kakaoUprc = receiveCash;
      this.complexUprc = 0;
    },
    //복합결제
    complexPay(type) {
      if (type == "001") {
        this.isCash = true;
      } else if (type == "002") {
        this.isKakaoPay = true;
      } else if (type == "003") {
        this.isCard = true;
      } else if (type == "004") {
        this.isMembershipPoint = true;
      } else if (type == "005") {
        this.isNaverPay = true;
      }
    },
    //페이징 이동
    groupChangePage(page) {
      this.groupCurrentPage = page;
    },
    //결제 팝업
    paymentModal(code) {
      if (code == "PAY009") {
        this.isClaim = true;
        return;
      }

      if (!this.isProdPay && this.baskets.length == 0 && code != "PAY007")
        return false;
      if (this.isProdPay && this.prodPayBaskets.length == 0) return false;

      this.payType = code;
      this.btnDisabled(true);
      if (!this.isProdPay) this.modalClose();

      if (code == "PAY001") this.isCard = true;
      else if (code == "PAY002") {
        this.prodPayCencel();
        this.isComplex = true;
      } else if (code == "PAY003") this.isMembershipPoint = true;
      else if (code == "PAY004") this.isCash = true;
      else if (code == "PAY005") this.isMembershipCoupon = true;
      else if (code == "PAY007") this.isReceipt = true;
      else if (code == "PAY008") {
        this.prodPayCencel();
        this.isDutchPayment = true;
      } else if (code == "PAY006") {
        this.isProdPay = true;
        this.btnDisabled(false);
      }
    },
    //사이드 팝업
    descModal(code) {
      // 카카오페이,네이버페이,사용매출 장바구니에 데이터 없으면 return fasle;
      if (
        this.baskets.length == 0 &&
        (code == "DESC005" || code == "DESC006" || code == "DESC004")
      )
        return false;

      if (code == "DESC002") {
        this.setPopupData(2);
        return false;
      }

      if (code == "DESC003") {
        this.$router.push("/order/table");
      }
      if (!this.isDiscount && code == "DESC010") this.modalClose();
      this.payType = code;

      this.btnDisabled(true);

      if (code == "DESC001") this.isProductSearch = true;
      else if (code == "DESC004") this.isUseSale = true;
      else if (code == "DESC005") this.isKakaoPay = true;
      else if (code == "DESC006") this.isNaverPay = true;
      else if (code == "DESC007") this.isReturnOrder = true;
      else if (code == "DESC008") this.isRestoreOrder = true;
      else if (code == "DESC009") this.isCoupon = true;
      else if (code == "DESC010") {
        // this.isDiscount
        //   ? ((this.isDiscount = false), this.btnDisabled(false))
        //   : (this.isDiscount = true);

        if (this.isDiscount) {
          this.isDiscount = false;
          this.btnDisabled(false);
        } else {
          this.isDiscount = true;
          this.isMemberInfo = false;
          this.isAddInfo = false;
        }
      } else if (code == "DESC011") this.isCustomerManagement = true;
      else if (code == "DESC012") this.isMembershipPoint = true;
      else if (code == "DESC013") this.isCustomerManagement = true;
    },
    //키패드 숨기기
    hideKeypad() {},
    // 메뉴 클릭 시 옵션 팝업
    optionModal(menu) {
      this.menuObj = menu;

      if (
        menu.setMenuIdx != null &&
        menu.setMenuIdx != "" &&
        menu.setMenuIdx != 0
      ) {
        this.isSelectOption = true;
      } else {
        this.isMenuOption = true;
      }
    },
    async setBasketOrder(optionList) {
      await this.addData(optionList); // basket에 담기

      await this.moveBtn(0); // 추가된 row에 커서 및 scroll 이동

      this.changeTotalQty(); // 갯수 세기

      let orderList = this.$store.getters.getOrderList;
      let idx = Math.max(...orderList.map((item) => item.orderIdx));

      if (this.$store.getters.getBaskets == null) {
        let newBasket = {
          menuArr: [],
          name: "게스트",
          orderIdx: ++idx,
          personnel: 2,
          startTime: "",
          tableIdx: 0,
        };
        let today = new Date();
        let h = today.getHours();
        let m = today.getMinutes();
        if (h < 10) h = "0" + h;
        if (m < 10) m = "0" + m;

        newBasket.startTime = h + ":" + m;
        newBasket.menuArr = this.baskets;
        orderList.push(newBasket);
        this.$store.dispatch("setBaskets", newBasket);
      } else {
        if (this.$store.getters.getBaskets.orderIdx == idx) {
          orderList.map((item) => {
            if (item.orderIdx == this.baskets.orderIdx) {
              item.menuArr = this.baskets;
            }
          });
        } else {
          let order = this.$store.getters.getBaskets;
          let today = new Date();
          let h = today.getHours();
          let m = today.getMinutes();
          if (h < 10) h = "0" + h;
          if (m < 10) m = "0" + m;

          order.startTime = h + ":" + m;
          order.menuArr = this.baskets;
          orderList.push(order);
        }
      }
      this.$store.dispatch("setOrderList", orderList);
    },
    addData(optionList) {
      let addMenu = _.cloneDeep(this.menuObj);
      addMenu.qty = 1;
      let optionPrice = 0;
      if (optionList != null && optionList.length != 0) {
        optionList.forEach((item) => {
          optionPrice += item.selectItemPrice * item.selectItemCnt;
        });

        addMenu.optionList = optionList;
      }

      this.totalUprc += addMenu.price * addMenu.qty + optionPrice;
      this.totalDiscount += addMenu.discount * addMenu.qty;
      this.baskets.push(addMenu);
      this.activeBasket = this.baskets.length - 1;
      this.menuObj = null;
    },
    modalClose() {
      this.isCard = false;
      this.isComplex = false;
      this.isMembershipPoint = false;
      this.isCash = false;
      this.isMembershipCoupon = false;

      this.isProductSearch = false;
      this.isRestoreOrder = false;
      this.isKakaoPay = false;
      this.isNaverPay = false;
      this.isReturnOrder = false;
      this.isMenuOption = false;

      this.isProdPay = false;
      this.isDiscount = false;
      this.isCustomerManagement = false;
      this.isDutchPayment = false;
      this.isReceipt = false;
    },
    qtyChange(cnt) {
      if (this.isReceipt) return false;
      if (this.activeBasket == -1) {
        this.popupText = "상품을 선택하세요.";
        this.popupTitle = cnt == 1 ? "수량증가" : "수량감소";
        this.isPopupBtn1 = true;
        return false;
      }

      // 선체크
      if (this.basketCheck() == false) return false;

      let basketIdx = this.activeBasket.toString().split("_")[0];
      let optionIdx =
        this.activeBasket.toString().split("_")[1] == null
          ? -1
          : this.activeBasket.split("_")[1];

      if (optionIdx > -1) {
        if (
          this.baskets[basketIdx].optionList[optionIdx].selectItemCnt + cnt ==
          0
        ) {
          this.popupText =
            "지정취소 실패!<br/>옵션상품은 지정취소 처리 불가입니다.<br/>옵션변경으로 처리해주세요";
          this.popupTitle = "지정취소";
          this.isPopupBtn1 = true;
          return false;
        }

        this.baskets[basketIdx].optionList[optionIdx].selectItemCnt += cnt;
        this.totalUprc +=
          this.baskets[basketIdx].optionList[optionIdx].selectItemPrice * cnt;
        this.totalDiscount +=
          this.baskets[basketIdx].optionList[optionIdx].selectItemDiscount *
          cnt;
        return false;
      }

      let basket = this.baskets[basketIdx];
      let prodTotalUprc = basket.price * basket.qty;
      let prodTotalDiscount = basket.discount * basket.qty;
      let changeOptionUprc = 0;
      let changeOptionDiscount = 0;
      basket.qty += cnt;

      if (basket.qty == 0) {
        if (basket.optionList != null && basket.optionList.length > 0) {
          basket.optionList.forEach((item) => {
            changeOptionUprc += item.selectItemPrice * item.selectItemCnt;
            changeOptionDiscount +=
              item.selectItemDiscount * item.selectItemCnt;
          });
        }

        this.totalUprc -= prodTotalUprc + changeOptionUprc;
        this.totalDiscount -= prodTotalDiscount + changeOptionDiscount;

        this.baskets.splice(this.activeBasket, 1);
      } else {
        let changeUprc = basket.price * cnt;
        let changeDiscount = basket.discount * cnt;

        if (basket.optionList != null && basket.optionList.length > 0) {
          basket.optionList.forEach((item) => {
            changeOptionUprc +=
              item.selectItemPrice * (basket.qty - item.selectItemCnt);
            changeOptionDiscount +=
              item.selectItemDiscount * (basket.qty - item.selectItemCnt);

            item.selectItemCnt = basket.qty;
          });
        }

        this.totalUprc += changeUprc + changeOptionUprc;
        this.totalDiscount += changeDiscount + changeOptionDiscount;
      }

      this.changeTotalQty(); // 갯수 없애기
    },
    qtyChangeKeyNum(keypadNum) {
      if (this.isReceipt) return false;
      // 선체크
      if (this.basketCheck() == false) return false;

      let basketIdx = this.activeBasket.toString().split("_")[0];
      let optionIdx =
        this.activeBasket.toString().split("_")[1] == null
          ? -1
          : this.activeBasket.split("_")[1];

      if (keypadNum == 0 && optionIdx > -1) {
        (this.popupText =
          "지정취소 실패!<br/>옵션상품은 지정취소 처리 불가입니다.<br/>옵션변경으로 처리해주세요"),
          (this.popupTitle = "지정취소");
        this.isPopupBtn1 = true;
        return false;
      }

      let cnt =
        keypadNum -
        (optionIdx > -1
          ? this.baskets[basketIdx].optionList[optionIdx].selectItemCnt
          : this.baskets[basketIdx].qty);
      this.qtyChange(cnt);
      this.keypadNum = "0";
      this.activeBasket = -1;
    },
    priceChangeKeyNum(keypadNum) {
      if (this.isReceipt) return false;
      // 선체크
      if (this.basketCheck() == false) return false;

      let basketIdx = this.activeBasket.toString().split("_")[0];
      let optionIdx =
        this.activeBasket.toString().split("_")[1] == null
          ? -1
          : this.activeBasket.split("_")[1];

      if (keypadNum == 0 && optionIdx > -1) {
        (this.popupText =
          "지정취소 실패!<br/>옵션상품은 지정취소 처리 불가입니다.<br/>옵션변경으로 처리해주세요"),
          (this.popupTitle = "지정취소");
        this.isPopupBtn1 = true;
        return false;
      }

      this.baskets[basketIdx].price = parseInt(keypadNum);
      this.changeTotalUprc();
      this.keypadNum = "0";
    },
    addNum(num) {
      let keyVal = this.keypadNum;
      if (this.isCash || this.isCashReceipts) keyVal = this.cashReceiveNum;

      if (num == "remove") {
        keyVal =
          keyVal.length == 1 ? "0" : keyVal.substring(0, keyVal.length - 1);
      } else if (keyVal == "0") {
        keyVal = num == "00" ? "0" : num;
      } else {
        keyVal = keyVal + num;
      }

      if (this.isCash || this.isCashReceipts) this.cashReceiveNum = keyVal;
      else this.keypadNum = keyVal;
    },
    prodDiscount(type) {
      // 선체크
      if (this.basketCheck() == false) return false;

      let basketIdx = this.activeBasket.toString().split("_")[0];
      let optionIdx =
        this.activeBasket.toString().split("_")[1] == null
          ? -1
          : this.activeBasket.split("_")[1];

      if (optionIdx > -1) {
        (this.popupText =
          "지정취소 실패!<br/>옵션상품은 지정취소 처리 불가입니다.<br/>옵션변경으로 처리해주세요"),
          (this.popupTitle = "지정취소");
        this.isPopupBtn1 = true;
        return false;
      }

      if (this.keypadNum.length == 0) {
        this.popupTitle = "할인";
        this.popupText = "할인금액을 입력하세요.";
        this.isPopupBtn1 = true;
        return false;
      }

      let basket = this.baskets[basketIdx];

      let discountPrice = 0;
      let discountNum = parseInt(this.keypadNum);

      if (type == "fix") {
        if (discountNum > basket.price) {
          this.popupTitle = "할인";
          this.popupText = "처리 실패!<br/>할인금액이 물품 가격보다 큽니다.";
          this.isPopupBtn1 = true;
          return false;
        }

        if (
          this.keypadNum.length == 1 ||
          this.keypadNum.substring(
            this.keypadNum.length - 1,
            this.keypadNum.length
          ) > 0
        ) {
          this.popupTitle = "할인";
          this.popupText =
            "처리 실패!<br/>1의 자리 숫자는 입력 할 수 없습니다.";
          this.isPopupBtn1 = true;
          return false;
        }
        discountPrice = parseInt(discountNum);
      } else if (type == "rate") {
        if (discountNum > 99) {
          this.popupTitle = "할인";
          this.popupText = "99이하로 설정해주세요.";
          this.isPopupBtn1 = true;
          return false;
        }

        discountPrice = Math.floor(basket.price / 100) * parseInt(discountNum);
      }

      this.totalDiscount += (discountPrice - basket.discount) * basket.qty;
      basket.discount = discountPrice;
      this.keypadNum = "0";
    },
    moveBtn(move) {
      if (this.isReceipt) return false;
      let table = document.querySelector("#bodyExp");
      let tr = table.querySelectorAll("tr");

      if (tr.length == 0) return false;

      let trIndex = -1;
      if (move == 0) trIndex = tr.length - 1;
      else {
        tr.forEach((item, index) => {
          if (item.classList == "bg-selected") trIndex = index;
        });
      }

      // selected가 없을 때
      if (trIndex == -1) trIndex = move == 1 ? tr.length - 1 : 0;
      else trIndex += move;

      if (tr[trIndex] == null) return false;

      this.activeBasket = tr[trIndex].id;

      if (move == 0 && tr[trIndex].id.indexOf("_") > 0) {
        this.activeBasket = tr[trIndex].id.split("_")[0];
      }

      let scrollTop = table.scrollTop;
      let scrollBottom = scrollTop + 32 * 9;
      let nextTr = trIndex * 32;

      if (nextTr >= scrollTop && nextTr + 32 <= scrollBottom) {
        return false;
      } else {
        move == -1 ? table.scroll(0, nextTr) : table.scroll(0, nextTr - 32 * 8);
      }
    },
    setPopupData(type) {
      if (this.baskets.length == 0 && type == 1) return false;
      if (this.isReceipt) return false;
      if (type == 1) {
        this.popupText = "일괄취소 하시겠습니까?";
        this.popupTitle = "";
        this.isPopupBtn2 = true;
        this.setYesType = type;
      } else if (type == 2) {
        if (this.baskets == null || this.baskets.length == 0) {
          this.modalClose();
          this.isRestoreOrder = true;
          this.payType = "DESC008";
          this.btnDisabled(true);
        } else {
          this.popupText = "보류 하시겠습니까?";
          this.popupTitle = "보류";
          this.isPopupBtn2 = true;
          this.setYesType = type;
        }
      }
    },
    resetBasket(payType) {
      if (this.isProdPay) {
        this.receivedUprc = this.prodAmount;
        this.prodAmount = 0;

        if (payType != null) this.prodComplete(payType);

        this.prodPayBaskets = [];
        if (this.totalUprc - this.totalDiscount - this.receivedUprc == 0) {
          this.baskets = [];
          this.totalUprc = 0;
          this.totalDiscount = 0;
          this.totalQty = 0;
          this.receivedUprc = 0;

          let orderList = this.$store.getters.getOrderList;
          let filteredArray = orderList.filter(
            (item) => item.orderIdx != this.$store.getters.getBaskets.orderIdx
          );

          if (payType != null) this.tableComplete(payType);
          this.$store.dispatch("setOrderList", filteredArray);

          if (this.tableYn == "Y") {
            this.$router.push("/order/table");
          }
        }

        this.$store.dispatch("setBaskets", this.baskets);
        this.isProdPay = false;
      } else {
        this.baskets = [];
        this.totalUprc = 0;
        this.totalDiscount = 0;
        this.totalQty = 0;
        this.receivedUprc = 0;

        let orderList = this.$store.getters.getOrderList;
        let filteredArray = orderList.filter(
          (item) => item.orderIdx != this.$store.getters.getBaskets.orderIdx
        );

        if (payType != null) this.tableComplete(payType);
        this.$store.dispatch("setOrderList", filteredArray);
        this.$store.dispatch("setBaskets", this.baskets);

        if (this.tableYn == "Y") {
          this.$router.push("/order/table");
        }
      }
    },
    removeItem() {
      // 선체크
      if (this.basketCheck() == false) return false;

      let basketIdx = this.activeBasket.toString().split("_")[0];
      let optionIdx =
        this.activeBasket.toString().split("_")[1] == null
          ? -1
          : this.activeBasket.split("_")[1];

      if (optionIdx > -1) {
        (this.popupText =
          "지정취소 실패!<br/>옵션상품은 지정취소 처리 불가입니다.<br/>옵션변경으로 처리해주세요"),
          (this.popupTitle = "지정취소");
        this.isPopupBtn1 = true;
        return false;
      }

      let basket = this.baskets[basketIdx];
      let removeUprc = basket.price * basket.qty;

      if (basket.optionList != null && basket.optionList.length > 0) {
        basket.optionList.forEach((item) => {
          removeUprc += item.selectItemPrice * item.selectItemCnt;
        });
      }

      this.totalUprc -= removeUprc;
      this.totalDiscount -=
        this.baskets[basketIdx].discount * this.baskets[basketIdx].qty;

      this.baskets.splice(basketIdx, 1);

      // 후 처리
      this.delCursor(); // 커서 삭제
    },
    // 선 체크
    basketCheck() {
      if (this.activeBasket == null || this.activeBasket == -1) return false;

      let table = document.querySelector("#bodyExp");
      let tr = table.querySelectorAll("tr");
      if (tr.length == 0) return false;
    },
    // 총 수량 변경
    changeTotalQty() {
      let qty = 0;
      this.baskets.forEach((item) => (qty += item.qty));
      this.totalQty = qty;
    },
    // 커서 없애기
    delCursor() {
      this.activeBasket = -1;
    },
    moveCashReceipts() {
      this.isCash = false;
      this.isCashReceipts = true;
    },
    openLoading(text) {
      this.isLoadingText = true;
      this.loadingText = text;
    },
    closeLoading() {
      this.isLoadingText = false;
      this.loadingText = "";
    },
    btnDisabled(flag) {
      this.activeBasket = flag == true ? -1 : this.activeBasket;
    },
    setYes() {
      if (this.setYesType == 1) this.resetBasket();
      else if (this.setYesType == 2) this.orderHold();
      this.isPopupBtn2 = false;
    },
    setReceivedUprc(usePoint, payType) {
      this.receivedUprc = usePoint;
      if (usePoint >= this.totalUprc - this.totalDiscount && payType != null) {
        this.resetBasket(payType);
      }
    },
    //완료처리
    tableComplete(payType) {
      let orderList = this.$store.getters.getOrderList;
      let table = this.$store.getters.getBaskets;

      if (
        orderList.filter((item) => item.orderIdx == table.orderIdx).length == 0
      )
        return;

      let filteredArray = orderList.filter(
        (item) => item.orderIdx != table.orderIdx
      );

      let salesList = this.$store.getters.getSalesList;
      let receiptList = this.$store.getters.getReceiptList;
      let idx = Math.max(...salesList.map((item) => item.salesIdx));
      let idx2 = Math.max(...receiptList.map((item) => item.receiptIdx));

      let order = orderList.filter(
        (item) => item.orderIdx == table.orderIdx
      )[0];

      let today = new Date();
      let year = today.getFullYear(); // 년도
      let month = today.getMonth() + 1; // 월
      let date = today.getDate(); // 날짜

      let h = today.getHours();
      let m = today.getMinutes();
      let s = today.getSeconds();
      if (h < 10) h = "0" + h;
      if (m < 10) m = "0" + m;
      if (s < 10) s = "0" + s;
      if (month < 10) month = "0" + month;
      if (date < 10) date = "0" + date;

      let sale = {
        salesIdx: ++idx,
        orderIdx: order.orderIdx,
        name: order.name,
        personnel: order.personnel,
        menuArr: order.menuArr,
        salesDate: year + "-" + month + "-" + date,
        salesTime: h + ":" + m + ":" + s,
      };
      salesList.push(sale);

      let amount = 0;
      order.menuArr.forEach((item) => {
        amount += item.price;
      });

      let receipt = {
        receiptIdx: ++idx2,
        salesIdx: sale.salesIdx,
        receiptDate: sale.salesDate,
        receiptTime: sale.salesTime,
        posNo: "0001",
        amount: amount,
        type: "RCP001", // 001 정상 002 반품
        receiptNo: "17004620",
        payType: payType, //001 신카 002 현금
        desc: JSON.stringify(sale),
      };
      receiptList.push(receipt);

      this.$store.dispatch("setReceiptList", receiptList);
      this.$store.dispatch("setSalesList", salesList);

      orderList = filteredArray;
      this.$store.dispatch("setOrderList", filteredArray);
    },
    orderHold() {
      let holdList = this.$store.getters.getHoldList;

      let today = new Date();
      let year = today.getFullYear(); // 년도
      let month = today.getMonth() + 1; // 월
      let date = today.getDate(); // 날짜

      let h = today.getHours();
      let m = today.getMinutes();
      let s = today.getSeconds();
      7;
      if (h < 10) h = "0" + h;
      if (m < 10) m = "0" + m;
      if (s < 10) s = "0" + s;
      if (month < 10) month = "0" + month;
      if (date < 10) date = "0" + date;

      let idx = Math.max(...holdList.map((item) => item.holdIdx));
      let hold = {
        holdIdx: ++idx,
        menuArr: [...this.baskets],
        totalUprc: this.totalUprc,
        totalDiscount: this.totalDiscount,
        receivedUprc: this.receivedUprc,
        salesDate: year + "-" + month + "-" + date,
        salesTime: h + ":" + m + ":" + s,
      };

      holdList.push(hold);

      this.$store.dispatch("setHoldList", holdList);
      this.tableYn = "N";
      this.resetBasket();
    },
    restoreOrder(baskets) {
      this.baskets = baskets.menuArr;
      this.$store.dispatch("setBaskets", baskets);
      this.changeTotalUprc();
    },
    changeTotalUprc() {
      this.baskets = this.baskets == null ? [] : this.baskets;

      if (this.baskets.length > 0) {
        let totalUprc = 0;
        let totalDiscount = 0;
        this.baskets.forEach((item) => {
          totalUprc += item.price * item.qty;
          totalDiscount += item.discount * item.qty;

          if (item.optionList != null) {
            item.optionList.forEach((optionItem) => {
              totalUprc +=
                optionItem.selectItemPrice * optionItem.selectItemCnt;
              totalDiscount +=
                optionItem.selectItemDiscount * optionItem.selectItemCnt;
            });
          }
        });

        this.totalUprc = totalUprc;
        this.totalDiscount = totalDiscount;
        this.receivedUprc =
          this.$store.getters.getBaskets.receivedUprc == null
            ? 0
            : this.$store.getters.getBaskets.receivedUprc;
        this.changeTotalQty();
      }
    },
    groupClick(groupIdx) {
      if (groupIdx == 0) return false;
      this.activeGroup = groupIdx;
    },
    addComplexPayArr(amount, type) {
      let obj = {
        idx: this.complexPayArr.length + 1,
        amount: amount,
        type: type,
      };

      let findIndex = this.complexPayArr.findIndex(
        (item) => item.type === type
      );

      if (findIndex == -1) this.complexPayArr.push(obj);
      else {
        this.complexPayArr[findIndex].amount =
          Number(amount) + Number(this.complexPayArr[findIndex].amount);

        if (type == "cash") {
          this.cashUprc = this.complexPayArr[findIndex].amount;
        } else if (type == "card") {
          this.cardUprc = this.complexPayArr[findIndex].amount;
        } else if (type == "kakao") {
          this.kakaoUprc = this.complexPayArr[findIndex].amount;
        } else if (type == "naver") {
          this.naverUprc = this.complexPayArr[findIndex].amount;
        } else if (type == "point") {
          this.membersUprc = this.complexPayArr[findIndex].amount;
        }
      }
    },
    removeComplexPayArr(idx) {
      if (idx == -1) {
        this.complexPayArr = [];
        return false;
      }
      if (this.complexPayArr.length >= idx) {
        let type = this.complexPayArr[idx].type;
        let amount = this.complexPayArr[idx].amount;

        if (type == "cash") {
          this.cashUprc -= amount;
          this.receivedUprc -= amount;
        } else if (type == "card") {
          this.cardUprc -= amount;
          this.receivedUprc -= amount;
        } else if (type == "kakao") {
          this.kakaoUprc -= amount;
          this.receivedUprc -= amount;
        } else if (type == "naver") {
          this.naverUprc -= amount;
          this.receivedUprc -= amount;
        } else if (type == "point") {
          this.membersUprc -= amount;
          this.receivedUprc -= amount;
        }

        this.complexPayArr.splice(idx, 1);
      }
    },
    //객층 등록
    tableSetBaskets(selectCustomerList) {
      if (this.$store.getters.getBaskets == null) {
        let tableList = this.$store.getters.getTableList;
        let orderList = this.$store.getters.getOrderList;
        let tableIdx;
        for (let item of tableList) {
          if (
            orderList.filter((item2) => item2.tableIdx == item.tableIdx)
              .length == 0
          ) {
            tableIdx = item.tableIdx;
            break;
          }
        }

        let idx = Math.max(...orderList.map((item) => item.orderIdx));
        let sum = 0;
        selectCustomerList.forEach((item) => {
          sum += Number(item.custNum);
        });

        let newBasket = {
          menuArr: [],
          name: "게스트",
          orderIdx: ++idx,
          personnel: 2,
          startTime: "",
          tableIdx: tableIdx,
          personnel: sum,
          ordererIdx: 2,
        };
        let today = new Date();
        let h = today.getHours();
        let m = today.getMinutes();
        if (h < 10) h = "0" + h;
        if (m < 10) m = "0" + m;

        newBasket.startTime = h + ":" + m;
        newBasket.menuArr = this.baskets;
        orderList.push(newBasket);

        this.$store.dispatch("setBaskets", newBasket);
      } else {
        let order = this.$store.getters.getBaskets;
        if (typeof order.ordererIdx == "undefined") order.ordererIdx = 2;
        if (order.tableIdx == 0) {
          let tableList = this.$store.getters.getTableList;
          let orderList = this.$store.getters.getOrderList;
          let tableIdx;
          for (let item of tableList) {
            if (
              orderList.filter((item2) => item2.tableIdx == item.tableIdx)
                .length == 0
            ) {
              tableIdx = item.tableIdx;
              break;
            }
          }
          order.tableIdx = tableIdx;
        }

        let sum = 0;
        selectCustomerList.forEach((item) => {
          sum += Number(item.custNum);
        });
        order.personnel = sum;
        this.$store.dispatch("setBaskets", order);
      }
      this.tableYn = "Y";
      this.isCustomerManagement = false;
      this.btnDisabled(false);
    },
    btnDisabled2(desc) {
      if (desc.code == "DESC010" && this.isDiscount) {
        return false;
      } else {
        return this.isDisabled ||
          (desc.code == "DESC003" && this.tableYn != "Y")
          ? true
          : false;
      }
    },
    cancelDiscount(type) {
      if (type == "s") {
        if (this.basketCheck() == false) return false;
        let basketIdx = this.activeBasket.toString().split("_")[0];

        let basket = this.baskets[basketIdx];

        this.totalDiscount += (0 - basket.discount) * basket.qty;
        basket.discount = 0;
      } else {
        this.baskets.forEach((basket) => {
          this.totalDiscount += (0 - basket.discount) * basket.qty;
          basket.discount = 0;
        });
      }
    },
    allDiscount(type) {
      if (this.keypadNum.length == 0) {
        this.popupTitle = "할인";
        this.popupText = "할인금액을 입력하세요.";
        this.isPopupBtn1 = true;
        return false;
      }
      this.baskets.forEach((basket) => {
        let discountPrice = 0;
        let discountNum = parseInt(this.keypadNum);

        if (type == "fix") {
          if (discountNum > basket.price) {
            this.popupTitle = "할인";
            this.popupText = "처리 실패!<br/>할인금액이 물품 가격보다 큽니다.";
            this.isPopupBtn1 = true;
            return false;
          }

          if (
            this.keypadNum.length == 1 ||
            this.keypadNum.substring(
              this.keypadNum.length - 1,
              this.keypadNum.length
            ) > 0
          ) {
            this.popupTitle = "할인";
            this.popupText =
              "처리 실패!<br/>1의 자리 숫자는 입력 할 수 없습니다.";
            this.isPopupBtn1 = true;
            return false;
          }
          discountPrice = parseInt(discountNum);
        } else if (type == "rate") {
          if (discountNum > 99) {
            this.popupTitle = "할인";
            this.popupText = "99이하로 설정해주세요.";
            this.isPopupBtn1 = true;
            return false;
          }

          discountPrice =
            Math.floor(basket.price / 100) * parseInt(discountNum);
        }

        this.totalDiscount += (discountPrice - basket.discount) * basket.qty;
        basket.discount = discountPrice;
      });

      this.keypadNum = "0";
    },
    dutchPay(type, amt) {
      if (type == "card") {
        this.isCard = true;
        this.dutchUprc = amt;
      } else {
        this.isCash = true;
        this.dutchUprc = amt;
      }
    },
    closeDutchCard(receiveCash) {
      this.isCard = false;
      this.btnDisabled(false);
      this.receivedUprc += Number(receiveCash);
      this.cardUprc = receiveCash;
      this.dutchUprc = 0;
    },
    closeDutchCash(receiveCash) {
      this.isCash = false;
      this.btnDisabled(false);
      this.receivedUprc += Number(receiveCash);
      this.cashUprc = receiveCash;
      this.dutchUprc = 0;
    },
    prodMove() {
      if (this.activeProdBasket != -1) {
        this.baskets.push(this.prodPayBaskets[this.activeProdBasket]);
        this.prodPayBaskets.splice(this.activeProdBasket, 1);
        this.activeProdBasket = -1;
      } else {
        if (this.activeBasket == -1) return;
        this.prodPayBaskets.push(this.baskets[this.activeBasket]);
        this.baskets.splice(this.activeBasket, 1);
        this.activeBasket = -1;
      }

      let totalUprc = 0;
      let totalDiscount = 0;
      this.prodPayBaskets.forEach((item) => {
        totalUprc += item.price * item.qty;
        totalDiscount += item.discount * item.qty;

        if (item.optionList != null) {
          item.optionList.forEach((optionItem) => {
            totalUprc += optionItem.selectItemPrice * optionItem.selectItemCnt;
            totalDiscount +=
              optionItem.selectItemDiscount * optionItem.selectItemCnt;
          });
        }
      });
      this.prodAmount = totalUprc - totalDiscount;
    },
    prodPayCencel() {
      this.prodPayBaskets.forEach((item) => {
        this.baskets.push(item);
      });
      this.prodPayBaskets = new Array();
      this.prodAmount = 0;
      this.isProdPay = false;
      this.btnDisabled(false);
      this.modalClose();
    },
    //완료처리
    prodComplete(payType) {
      let orderList = this.$store.getters.getOrderList;
      let table = this.$store.getters.getBaskets;

      if (
        orderList.filter((item) => item.orderIdx == table.orderIdx).length == 0
      )
        return;

      let salesList = this.$store.getters.getSalesList;
      let receiptList = this.$store.getters.getReceiptList;
      let idx = Math.max(...salesList.map((item) => item.salesIdx));
      let idx2 = Math.max(...receiptList.map((item) => item.receiptIdx));

      let order = orderList.filter(
        (item) => item.orderIdx == table.orderIdx
      )[0];

      let today = new Date();
      let year = today.getFullYear(); // 년도
      let month = today.getMonth() + 1; // 월
      let date = today.getDate(); // 날짜

      let h = today.getHours();
      let m = today.getMinutes();
      let s = today.getSeconds();
      if (h < 10) h = "0" + h;
      if (m < 10) m = "0" + m;
      if (s < 10) s = "0" + s;
      if (month < 10) month = "0" + month;
      if (date < 10) date = "0" + date;

      let sale = {
        salesIdx: ++idx,
        orderIdx: order.orderIdx,
        name: order.name,
        personnel: order.personnel,
        menuArr: this.prodPayBaskets,
        salesDate: year + "-" + month + "-" + date,
        salesTime: h + ":" + m + ":" + s,
      };
      salesList.push(sale);

      let amount = 0;
      this.prodPayBaskets.forEach((item) => {
        amount += item.price;
      });

      let receipt = {
        receiptIdx: ++idx2,
        salesIdx: sale.salesIdx,
        receiptDate: sale.salesDate,
        receiptTime: sale.salesTime,
        posNo: "0001",
        amount: amount,
        type: "RCP001", // 001 정상 002 반품
        receiptNo: "17004620",
        payType: payType, //001 신카 002 현금
        desc: JSON.stringify(sale),
      };
      receiptList.push(receipt);

      this.$store.dispatch("setReceiptList", receiptList);
      this.$store.dispatch("setSalesList", salesList);
      this.changeTotalUprc();
    },
    prodBasketMove(moveY) {
      var scroll = document.getElementById("prodBasketScroll");
      scroll.scrollTop += moveY;
      //scroll.scrollTo({ top: scroll.scrollHeight + moveY, behavior: "smooth" });
    },
    claimNotice(message) {
      this.isClaim = false;
      this.claimMessage = message;
      this.isNotice = true;
      this.$store.getters.getBaskets.isNotice = true;
      this.$store.getters.getBaskets.claimMessage = message;
    },
    applyCoupon(coupon) {
      if (this.activeBasket == -1) return;
      let discountPrice;
      let basket = this.baskets[this.activeBasket];
      if (coupon.discountType == "rate") {
        discountPrice =
          Math.floor(basket.price / 100) * parseInt(coupon.amount);
      } else {
        discountPrice = parseInt(coupon.amount);
      }
      basket.discount = discountPrice;
      this.changeTotalUprc();
    },
    setReceiptBaskets(receiptBasket) {
      this.receiptBasket = receiptBasket;
    },
    popupOpen(popupTitle, popupText) {
      this.popupTitle = popupTitle;
      this.popupText = popupText;
      this.isPopupBtn1 = true;
      return false;
    },
  },
  watch: {},
  computed: {
    titleName() {
      let tableList = this.$store.getters.getTableList;
      let tableIdx =
        this.$store.getters.getBaskets == null
          ? 0
          : this.$store.getters.getBaskets.tableIdx;
      if (tableList.filter((item) => item.tableIdx == tableIdx).length > 0) {
        let table = tableList.filter((item) => item.tableIdx == tableIdx)[0];
        return table.name;
      } else {
        return "회현점";
      }
    },
    tableTime() {
      let today = new Date();
      let year = today.getFullYear(); // 년도
      let month = today.getMonth() + 1; // 월
      let date = today.getDate(); // 날짜

      let h = today.getHours();
      let m = today.getMinutes();
      let s = today.getSeconds();
      if (h < 10) h = "0" + h;
      if (m < 10) m = "0" + m;
      if (s < 10) s = "0" + s;
      if (month < 10) month = "0" + month;
      if (date < 10) date = "0" + date;

      if (this.tableYn == "Y") {
        return h + ":" + m + ":" + s;
      } else {
        return year + "-" + month + "-" + date;
      }
    },
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {
    if (this.receiptYn == "Y") {
      if (this.baskets != null && this.baskets.length == 0) {
        this.isReceipt = true;
      }
    }
    this.changeTotalUprc();

    if (this.$store.getters.getBaskets == null) {
      this.paymentList.forEach((item, index) => {
        if (item.idx == 5) {
          item.row = 2;
        } else if (item.idx == 7) {
          this.paymentList.splice(index, 1);
        }
      });
    } else {
      if (this.$store.getters.getBaskets.isNotice == true) {
        this.isNotice = true;
        this.claimMessage = this.$store.getters.getBaskets.claimMessage;
      }
    }
  },
  unmounted() {},
  components: {
    MainPaging: mainPaging,
    CardPayment: cardPayment,
    CashPayment: cashPayment,
    ComplexPayment: complexPayment,
    CashReceipt: cashReceipt,
    MembershipPoint: membershipPoint,
    MembershipCoupon: membershipCoupon,
    ProductSearch: productSearch,
    KakaoPay: kakaoPay,
    NaverPay: naverPay,
    RestoreOrder: restoreOrder,
    ReturnOrder: returnOrder,
    Keypad: keypad,
    MenuOption: menuOption,
    PopupBtn1: popupBtn1,
    PopupBtn2: popupBtn2,
    Receipt: receipt,
    LoadingText: loadingText,
    UseSale: useSale,
    CustomerManagement: customerManagement,
    DutchPayment: dutchPayment,
    Claim: claim,
    Coupon: coupon,
    OrderMenuSelectOption: orderMenuSelectOption,
  },
};
</script>

<style src="@/assets/css/style.css" scoped></style>
<style scoped>
.loading-wrap {
  position: ABSOLUTE;
  width: 100%;
  height: 100%;
  background: var(--bg-pop-color);
  top: 0;
  z-index: 500;
}

.ft-sm {
  font-size: 0.9em !important;
}

.mn-name {
  white-space: pre-line;
}
</style>
